import {Circle, Group, Line} from "react-konva";
import {gridToImage} from "@/dungeons/geometry/Coordinates.ts";
import type {GridPoint, LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";
import type {GeometryEditorTool} from "./GeometryEditorTypes.ts";
import type {GeometrySnapResult} from "./GeometrySnapping.ts";
import GeometrySnapPreviewOverlay from "./GeometrySnapPreviewOverlay.tsx";

export default function GeometryDraftOverlay({geometry, tool, wallDraft, transitionDraft, doorDraft, cursorSnap, zoom}: {
    geometry: LevelGeometryDocument;
    tool: GeometryEditorTool;
    wallDraft: GridPoint[];
    transitionDraft: GridPoint[];
    doorDraft?: GridPoint;
    cursorSnap?: GeometrySnapResult;
    zoom: number;
}) {
    const wallPreview = tool === "wall" && cursorSnap ? [...wallDraft, cursorSnap.point] : wallDraft;
    const transitionPreview = tool === "transition" && cursorSnap
        ? [...transitionDraft, cursorSnap.point] : transitionDraft;
    const doorStart = tool === "door" && doorDraft ? gridToImage(doorDraft, geometry.registration) : undefined;
    const doorEnd = tool === "door" && cursorSnap
        ? gridToImage(cursorSnap.point, geometry.registration)
        : undefined;

    return <Group listening={false}>
        {tool === "wall" && wallPreview.length > 1 && <Line points={wallPreview.flatMap(point => {
            const image = gridToImage(point, geometry.registration);
            return [image.x, image.y];
        })} stroke="#22d3ee" strokeWidth={3 / zoom} lineCap="round" lineJoin="round"/>}
        {tool === "wall" && wallDraft.map((point, index) => {
            const image = gridToImage(point, geometry.registration);
            return <Circle key={index} x={image.x} y={image.y} radius={5 / zoom}
                           fill="#22d3ee" stroke="white" strokeWidth={1.5 / zoom}/>;
        })}
        {tool === "transition" && transitionPreview.length > 1 && <Line
            points={transitionPreview.flatMap(point => {
                const image = gridToImage(point, geometry.registration);
                return [image.x, image.y];
            })} closed={transitionDraft.length >= 3} fill="rgba(34,197,94,0.18)"
            stroke="#22c55e" strokeWidth={3 / zoom} lineJoin="round"/>}
        {tool === "transition" && transitionDraft.map((point, index) => {
            const image = gridToImage(point, geometry.registration);
            return <Circle key={index} x={image.x} y={image.y} radius={5 / zoom}
                fill="#22c55e" stroke="white" strokeWidth={1.5 / zoom}/>;
        })}
        {doorStart && doorEnd && <Line points={[doorStart.x, doorStart.y, doorEnd.x, doorEnd.y]}
                                      stroke="#f59e0b" strokeWidth={5 / zoom} lineCap="round"/>}
        {doorStart && <Circle x={doorStart.x} y={doorStart.y} radius={6 / zoom}
                              fill="#f59e0b" stroke="white" strokeWidth={2 / zoom}/>}
        <GeometrySnapPreviewOverlay geometry={geometry} snap={cursorSnap} zoom={zoom}/>
    </Group>;
}
